import React, {useState, useEffect, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { handleFaltas, handlePromedio } from '../../helpers/handlerFunctions';
import { Col } from 'reactstrap';
import { GlobalContext } from '../../context/GlobalContext';

export const CardMateria = ({ data = {}, darkTheme }) => {

    const context = useContext(GlobalContext);
    const { Calificaciones } = context;
    const navigate = useNavigate();
    const [nombre, setNombre] = useState('');

    useEffect(()=>{
        const clave = data.relationships.materiaRelacionada.data.id;
        const included = Calificaciones.included.find(i => i.id == clave && i.type == "materias");
        setNombre(included.attributes.nombreMateria);
    },[]);

    const handleClick = () => {
        navigate(`/detalles/${data.relationships.materiaRelacionada.data.id}`);
    }

    return (
        <Col xs="12" md="6">
            <div className={(darkTheme) ? "card margin-primary bg-dark-secondary" : "card margin-primary"}>
                <div className="materia-flex-container">
                    <span className="name">{nombre}</span>
                    <span className="promedio">{handlePromedio(data.attributes.promedio)}</span>
                </div>
                <span className="faltas">Faltas: {handleFaltas(data.attributes.limiteFaltas, data.attributes.numeroFaltas)}</span>
                <span className="ver-mas" onClick={handleClick}>Ver detalles</span>
            </div>
        </Col>
    )
}
